import Constants from '../../constants'
import i18n from '../../i18n'
import _ from 'lodash'

const getDefaultState = () => {
  return {
    token: null,
    lang: null,
    filter: {},
    bearers: {},
    appId: null,
    rtwebAccept: false
  }
}

const state = getDefaultState()

const getters = {
  getToken: (state) => state.token,
  getLang: (state) => state.lang,
  getAppId: (state) => state.appId,
  isFilterOn: (state) => (genre) => {
    return !!state.filter[genre.id]
  },
  getFilter: (state) => state.filter,
  getRTWebAccept:(state)=> state.rtwebAccept
}

const actions = {
  setToken ({ commit }, params) {
    commit('setToken', { token: params })
  },
  setAppId ({ commit }) {
    commit('setAppId')
  },
  resetToken ({ commit }) {
    commit('resetToken')
  },
  setLang ({ commit }, params) {
    if (Constants.AVAILABLE_LANGUAGES.includes(params)) {
      i18n.locale = params
    } else {
      i18n.locale = 'ja'
    }
    commit('setLang', { lang: i18n.locale })
  },
  onFilterFromTag ({ commit }, tagId) {
    const genre = {
      id: tagId
    }
    commit('setOnFilter', genre)
  },
  offFilterFromTag ({ commit }, tagId) {
    const genre = {
      id: tagId
    }
    commit('setOffFilter', genre)
  },
  onFilter ({ commit }, genre) {
    commit('setOnFilter', genre)
  },
  offFilter ({ commit }, genre) {
    commit('setOffFilter', genre)
  },
  onFilterAll ({ commit }) {
    commit('setOnFilterAll')
  },
  offFilterAll ({ commit }) {
    commit('setOffFilterAll')
  },
  updateFilter ({ commit, state }, genres) {
    var filter = {};
    if (state.filter !== undefined && !_.isEmpty(state.filter)) {
      filter = Object.assign({}, state.filter);
    }
    genres.forEach((genre) => {
      if (filter[genre.id] === undefined) {
        filter[genre.id] = genre.filterDefault
        if (genre.children) {
          genre.children.forEach((child) => {
            if (filter[child.id] === undefined) {
              filter[child.id] = child.filterDefault
            }
          })
        }
      }
    })
    commit('setFilter', filter)
  },
  setFilter ({ commit }, genres) {
    var filter = {};
    genres.forEach((genre) => {
      filter[genre.id] = genre.filterDefault
      if (genre.children) {
        genre.children.forEach((child) => {
          filter[child.id] = child.filterDefault
        })
      }
    })
    commit('setFilter', filter)
  },
  setRTWebAccept({ commit }) {
    commit('setRTWebAccept')
  },
  reset ({ commit }) {
    commit('resetState')
  }
}

const mutations = {
  setToken (state, { token }) {
    state.token = token
  },
  setAppId (state) {
    state.appId = Constants.API_ID
  },
  resetToken (state) {
    state.token = null
  },
  setLang (state, { lang }) {
    state.lang = lang
  },
  setFilter (state, genres) {
    state.filter = genres
  },
  setOnFilter (state, genre) {
    state.filter[genre.id] = true
    if (genre.relatedFilters !== undefined) {
      for (var i = 0; i < genre.relatedFilters.length; i++) {
        state.filter[genre.relatedFilters[i]] = true
      }
    }
  },
  setOffFilter (state, genre) {
    state.filter[genre.id] = false
    if (genre.relatedFilters !== undefined) {
      for (var i = 0; i < genre.relatedFilters.length; i++) {
        state.filter[genre.relatedFilters[i]] = false
      }
    }
  },
  setOnFilterAll (state) {
    for (let key in state.filter) {
      state.filter[key] = true
    }
  },
  setOffFilterAll (state) {
    for (let key in state.filter) {
      state.filter[key] = false
    }
  },
  setRTWebAccept(state) {
    state.rtwebAccept = true
  },
  resetState (state) {
    Object.assign(state, getDefaultState())
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
